import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';

import {
    ActionIcon,
    Badge,
    Box,
    Flex,
    ScrollArea
} from '@mantine/core';

import { DocumentDto } from '../../api/models';
import DocumentOverview from './DocumentOverview.tsx';

interface SelectedDocumentInfo {
    document: DocumentDto;
    projectName: string;
}

interface NavbarProps {
    isExpanded?: boolean;
    onToggle?: () => void;
    selectedDocumentInfo?: SelectedDocumentInfo;
    onSelectedDocumentInfoChange?: (
        info: SelectedDocumentInfo | undefined
    ) => void;
    onBeforeNavigate?: () => boolean;
}

const Navbar = ({
    isExpanded = true,
    onToggle,
    selectedDocumentInfo,
    onSelectedDocumentInfoChange,
    onBeforeNavigate
}: NavbarProps) => {
    if (!isExpanded) {
        return (
            <nav style={{ height: '100%' }}>
                <Flex
                    direction='column'
                    align='center'
                    style={{ height: '100%' }}
                    p='xs'
                >
                    {onToggle && (
                        <ActionIcon
                            variant='subtle'
                            size='sm'
                            color='gray'
                            onClick={onToggle}
                            title='Expand sidebar'
                        >
                            <IconChevronRight size='1rem' />
                        </ActionIcon>
                    )}
                </Flex>
            </nav>
        );
    }

    return (
        <nav style={{ height: '100%' }}>
            <Flex
                justify='space-between'
                direction='column'
                style={{ height: '100%' }}
            >
                <div style={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
                    <Flex direction='row' style={{ height: '100%' }}>
                        <Box style={{ flex: 1, minWidth: 0, overflow: 'hidden', height: '100%' }}>
                            <ScrollArea style={{ height: '100%' }} type="scroll" scrollbars="y">
                                <DocumentOverview
                                    selectedDocumentInfo={selectedDocumentInfo}
                                    onSelectedDocumentInfoChange={
                                        onSelectedDocumentInfoChange
                                    }
                                    onBeforeNavigate={onBeforeNavigate}
                                />
                            </ScrollArea>
                        </Box>
                        {onToggle && (
                            <Flex
                                direction='column'
                                justify='flex-start'
                                align='center'
                                pl='xs'
                                pt='xs'
                            >
                                <ActionIcon
                                    variant='subtle'
                                    size='sm'
                                    color='gray'
                                    onClick={onToggle}
                                    title='Collapse sidebar'
                                >
                                    <IconChevronLeft size='1rem' />
                                </ActionIcon>
                            </Flex>
                        )}
                    </Flex>
                </div>

                <Box py='xs' px='md' style={{ borderTop: '1px solid var(--mantine-color-default-border)' }}>
                    <Badge
                        color='secondary'
                        variant='light'
                        size='sm'
                        tt='none'
                        style={{ fontFamily: 'monospace', fontWeight: 700 }}
                    >
                        {import.meta.env.VITE_WEB_APP_VERSION}
                    </Badge>
                </Box>
            </Flex>
        </nav>
    );
};

export default Navbar;
